export default __webpack_public_path__ + "static/media/pp-logo-black.f90d2f6c.svg";